<template>
  <div class="d-flex align-center" data-testid="notification-header">
    <PageHeader 
      :title="$nova.labelsName('user_management', 'threshold_label', 'User Permission')"
      :loading="loading"
      @refresh="$emit('refresh')"
    />
    <v-spacer></v-spacer>
    <v-tooltip left content-class="tooltip-left" v-if="isUserPermissionsEnabled">
      <template v-slot:activator="{ on, attrs }">
        <base-button 
          v-bind="attrs"
          v-on="on"
          data-testid="data-table-new__sort-btn-none" 
          image="/img/icons/DocumentaryIcon.svg"
          image-alt="Documentary"
          icon-style
          image-width="20"
          class=""
          @click="$emit('bulk-upload-click')"
        />
      </template>
      <span>Bulk Upload Users</span>
    </v-tooltip>
  </div>
</template>

<script>
import PageHeader from '../../../components/PageHeader.vue';

export default {
  name: 'UserPermissionHeader',
  components: {
    PageHeader
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    isUserPermissionsEnabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>
